import { Box, Modal } from "fds";
import { useTranslation } from "react-i18next";

interface TitleObject {
  [key: string]: string;
}

export type ModalProps = {
  showViewChangeLocation: { view: boolean; type: string };
  toggleViewChangeLocation: (showViewChangeLocation: {
    view: boolean;
    type: string;
  }) => void;
};

const ViewChangeLocationModal: React.FC<ModalProps> = ({
  showViewChangeLocation,
  toggleViewChangeLocation,
}) => {
  const { t } = useTranslation();

  const setTitle: TitleObject = {
    login: t("admin.whiteLabel.changeLogin"),
    main: t("admin.whiteLabel.changeMain"),
    email: t("admin.whiteLabel.changeEmailTemplate"),
    client: t("admin.whiteLabel.changeClient"),
    service: t("admin.whiteLabel.serviceGuide"),
  };

  return (
    <Modal
      open={showViewChangeLocation.view}
      onClose={() =>
        toggleViewChangeLocation({
          view: false,
          type: "",
        })
      }
      title={setTitle[showViewChangeLocation.type]}
      width={1075}
      body={
        <Box
          width={"100%"}
          height={"100%"}
          alignItems="center"
          justifyContent="center"
        >
          {showViewChangeLocation.type === "login" && (
            <Box
              alignItems="center"
              justifyContent="center"
              width={"100%"}
              height={"100%"}
            >
              <img
                src={`/whitelabel_images/login${
                  window.navigator.language === "ko" ? "" : "_eng"
                }.png`}
                alt="login"
                width={1024}
                height={640}
              />
            </Box>
          )}

          {showViewChangeLocation.type === "main" && (
            <Box
              width={"100%"}
              height={"100%"}
              justifyContent="center"
              alignItems="center"
            >
              <img
                src={`/whitelabel_images/main_user${
                  window.navigator.language === "ko" ? "" : "_eng"
                }.png`}
                alt="main_user"
                width={1024}
                height={640}
              />
            </Box>
          )}

          {showViewChangeLocation.type === "email" && (
            <Box
              // direction="row"
              width={"100%"}
              height={"100%"}
              justifyContent="center"
              alignItems="center"
            >
              <img
                src={`/whitelabel_images/email_template${
                  window.navigator.language === "ko" ? "" : "_eng"
                }.png`}
                alt="email_template"
                width={964}
                height={640}
              />
            </Box>
          )}

          {showViewChangeLocation.type === "client" && (
            <Box
              // direction="row"
              width={"100%"}
              height={"100%"}
              justifyContent="center"
              alignItems="center"
            >
              <img
                src={`/whitelabel_images/client${
                  window.navigator.language === "ko" ? "" : "_eng"
                }.png`}
                alt="login"
                width={"480px"}
                height={"640px"}
              />
            </Box>
          )}

          {showViewChangeLocation.type === "service" && (
            <Box
              width={"100%"}
              height={"100%"}
              justifyContent="center"
              alignItems="center"
            >
              <img
                src={`/whitelabel_images/service_intro${
                  window.navigator.language === "ko" ? "" : "_eng"
                }.png`}
                alt="login"
                width={1024}
                height={640}
              />
            </Box>
          )}
        </Box>
      }
    />
  );
};
export default ViewChangeLocationModal;
